/****
 * 這是對OSS相關方法的封裝
 **/

import ccVueUtils from "cc-vue-utils";

var _config = {
  getAuthorizationURL: "admin/merchant/aliyun/uploadToken",
  bucket: process.env.VUE_APP_OSS_BUCKET, // cos buket   //nrapp-trail 灰度   nrapp-prd 正式   cong-test//測試
  bucketType: "private",
  endpoint: process.env.VUE_APP_ENDPOINT, //oss-cn-shenzhen.aliyuncs.com 測試  oss-cn-hongkong.aliyuncs.com\\正式灰度
  myFolder: "/", //
  privateDownloadUrlApi: "admin/merchant/aliyun/privateDownloadUrl",
};

var _configPublish = {
  getAuthorizationURL: "admin/merchant/aliyun/uploadToken",
  bucket: process.env.VUE_APP_OSS_BUCKET,
  bucketType: "public",
  endpoint: process.env.VUE_APP_ENDPOINT,
  myFolder: "/pic/", // cos folder
  fileType: "image",
};

/***
 * 獲取私有桶的下載地址
 *  */
function _getPrivateDownloadUrl(url) {
  return new Promise(function(resolve, reject) {
    let d = {
      url: url,
    };
    ccVueUtils.ccRequest
      .do(_config.privateDownloadUrlApi, d)
      .then((res) => {
        resolve(res.url);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function configPublishV2(myFolder) {
  return {
    getAuthorizationURL: "admin/merchant/aliyun/uploadToken",
    bucket: process.env.VUE_APP_OSS_BUCKET,
    bucketType: "public",
    endpoint: process.env.VUE_APP_ENDPOINT,
    myFolder: myFolder, 
    fileType: "image",
    NoBease64: true,
  };
}

export default {
  config: _config,
  configPublish: _configPublish,
  configPublishV2: configPublishV2,
  getPrivateDownloadUrl: _getPrivateDownloadUrl,
};
